/**
 * CRO PDP — Livera Skin Shield
 * Template: skin-shield-ruda
 */

(function () {
  'use strict';

  // ===== VARIANT SELECTOR =====
  var selectedVariantId = null;
  var selectedPrice = null;
  var selectedCompare = null;

  function initVariants() {
    var cards = document.querySelectorAll('.ss-variant-card');
    if (!cards.length) return;

    // Select first card by default
    selectVariantCard(cards[0]);

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectVariantCard(card);
      });
    });
  }

  function selectVariantCard(card) {
    document.querySelectorAll('.ss-variant-card').forEach(function (c) {
      c.classList.remove('ss-variant-card--selected');
    });
    card.classList.add('ss-variant-card--selected');
    selectedVariantId = card.dataset.variantId;
    selectedPrice = card.dataset.price;
    selectedCompare = card.dataset.compare;

    // Update price summary
    var priceEl = document.getElementById('ss-price-main');
    var compareEl = document.getElementById('ss-price-compare');
    var savingEl = document.getElementById('ss-price-saving');
    var perDayEl = document.getElementById('ss-price-perday');
    if (priceEl) priceEl.textContent = card.dataset.priceFormatted;
    if (compareEl) compareEl.textContent = card.dataset.compareFormatted;
    if (savingEl) {
      var saving = (parseInt(card.dataset.compare) - parseInt(card.dataset.price));
      savingEl.textContent = 'Je bespaart €' + (saving / 100).toFixed(2).replace('.', ',') + ' op dit pakket';
    }
    if (perDayEl) perDayEl.textContent = card.dataset.perDay;

    // Update sticky ATC
    var stickyPrice = document.querySelector('.ss-sticky-atc__price');
    if (stickyPrice) stickyPrice.textContent = card.dataset.priceFormatted;

    // Update mid-page ATC
    document.querySelectorAll('.ss-mid-atc__variant').forEach(function (v) {
      v.classList.toggle('ss-mid-atc__variant--selected', v.dataset.variantId === selectedVariantId);
    });
  }

  // ===== MID-PAGE ATC VARIANTS =====
  function initMidAtcVariants() {
    var variants = document.querySelectorAll('.ss-mid-atc__variant');
    variants.forEach(function (v) {
      v.addEventListener('click', function () {
        // Sync with main variant selector
        var mainCard = document.querySelector('.ss-variant-card[data-variant-id="' + v.dataset.variantId + '"]');
        if (mainCard) selectVariantCard(mainCard);
      });
    });
  }

  // ===== ADD TO CART =====
  function addToCart(variantId) {
    var btns = document.querySelectorAll('.ss-atc-btn, .ss-mid-atc__btn');
    btns.forEach(function (b) { b.classList.add('ss-atc-btn--loading'); b.textContent = 'Toevoegen...'; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) {
          console.error('Cart error:', data.description);
          btns.forEach(function (b) { b.classList.remove('ss-atc-btn--loading'); b.textContent = 'In winkelwagen'; });
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Cart error:', err);
        btns.forEach(function (b) { b.classList.remove('ss-atc-btn--loading'); b.textContent = 'In winkelwagen'; });
      });
  }

  // ===== STICKY ATC =====
  function initStickyAtc() {
    var hero = document.querySelector('.ss-hero');
    var sticky = document.querySelector('.ss-sticky-atc');
    if (!hero || !sticky) return;

    window.addEventListener('scroll', function () {
      var heroBottom = hero.getBoundingClientRect().bottom;
      sticky.classList.toggle('ss-sticky-atc--visible', heroBottom < 0);
    }, { passive: true });

    var stickyBtn = sticky.querySelector('.ss-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (selectedVariantId) addToCart(selectedVariantId);
      });
    }
  }

  // ===== ATC BUTTONS =====
  function initAtcButtons() {
    document.querySelectorAll('.ss-atc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (selectedVariantId) addToCart(selectedVariantId);
      });
    });
    document.querySelectorAll('.ss-mid-atc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (selectedVariantId) addToCart(selectedVariantId);
      });
    });
  }

  // ===== GALLERY =====
  function initGallery() {
    var mainImg = document.getElementById('ss-main-img');
    var thumbs = document.querySelectorAll('.ss-gallery__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
        thumbs.forEach(function (t) { t.classList.remove('ss-gallery__thumb--active'); });
        thumb.classList.add('ss-gallery__thumb--active');
      });
    });
  }

  // ===== INGREDIENT TABS =====
  function initIngredientTabs() {
    var tabs = document.querySelectorAll('.ss-ingredient-tab');
    var panels = document.querySelectorAll('.ss-ingredient-panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.ingredient;
        tabs.forEach(function (t) { t.classList.remove('ss-ingredient-tab--active'); });
        panels.forEach(function (p) { p.classList.remove('ss-ingredient-panel--active'); });
        tab.classList.add('ss-ingredient-tab--active');
        var panel = document.getElementById('ss-ingredient-' + target);
        if (panel) panel.classList.add('ss-ingredient-panel--active');
      });
    });

    // Activate first tab
    if (tabs[0]) tabs[0].click();
  }

  // ===== FAQ =====
  function initFaq() {
    document.querySelectorAll('.ss-faq-item__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ss-faq-item');
        item.classList.toggle('ss-faq-item--open');
      });
    });
  }

  // ===== INIT =====
  document.addEventListener('DOMContentLoaded', function () {
    initVariants();
    initMidAtcVariants();
    initAtcButtons();
    initStickyAtc();
    initGallery();
    initIngredientTabs();
    initFaq();
  });
})();
